export const azureVmPaths = {
  list: (connectionId) => `/compute/cloud-account-connections/${connectionId}/azure/vms`,
  create: (connectionId) => `/compute/cloud-account-connections/${connectionId}/azure/vms`,
  sizes: (connectionId, location) =>
    `/compute/cloud-account-connections/${connectionId}/azure/vm-sizes?location=${encodeURIComponent(location)}`,
  detail: (connectionId, resourceGroup, name) =>
    `/compute/cloud-account-connections/${connectionId}/azure/vms/${encodeURIComponent(resourceGroup)}/${encodeURIComponent(name)}`,
  action: (connectionId, resourceGroup, name, action) =>
    `/compute/cloud-account-connections/${connectionId}/azure/vms/${encodeURIComponent(resourceGroup)}/${encodeURIComponent(name)}/${encodeURIComponent(action)}`,
  attachDisk: (connectionId, resourceGroup, name) =>
    `/compute/cloud-account-connections/${connectionId}/azure/vms/${encodeURIComponent(resourceGroup)}/${encodeURIComponent(name)}/attach-disk`,
  detachDisk: (connectionId, resourceGroup, name) =>
    `/compute/cloud-account-connections/${connectionId}/azure/vms/${encodeURIComponent(resourceGroup)}/${encodeURIComponent(name)}/detach-disk`,
};
